import KeysTable from './KeysTable';

export default KeysTable;
